import React from 'react'
import { Table } from '@imcva/reactstrap-table'
import { columns } from './columns'

const Loading: React.FC = (props) => {
  return (
    <Table
      suspend={3}
      options={{
        data: [],
        columns: columns(),
        initialState: { sorting: [{ id: 'name', desc: false }] }
      }}
    />
  )
}

export default Loading
